import React from "react";
import { cn } from "@/lib/utils";
import TextCardListedLocations, {
  TextCardListedLocationsProps,
} from "@/components/ui/text-card-listed-locations";
import useEmblaCarousel from "embla-carousel-react";

export interface OtherLocationsProps {
  id?: string;
  className?: string;
  heading?: string;
  locations: TextCardListedLocationsProps[];
}

export const defaultProps = {
  heading: "Other Locations",
  locations: [
    {
      title: "San Francisco",
      items: [
        {
          icon: "map-pin",
          text: "50 California Street, Suite 1500, San Francisco, CA 94111",
          href: "#",
        },
        { icon: "phone", text: "(650) 328-1001", href: "tel:(650) 328-1001" },
        {
          icon: "mail",
          text: "info@careindeed.com",
          href: "mailto:info@careindeed.com",
        },
        { icon: "clock", text: "9:00 AM - 5:30 PM" },
      ],
      button: {
        color: "orange",
        children: "Reach Out to Us",
      },
      href: "#",
    },
    {
      title: "Walnut Creek",
      items: [
        {
          icon: "map-pin",
          text: "2121 North California Blvd., Suite 290, Walnut Creek, CA 94596",
          href: "#",
        },
        { icon: "phone", text: "(650) 328-1001", href: "tel:(650) 328-1001" },
        {
          icon: "mail",
          text: "info@careindeed.com",
          href: "mailto:info@careindeed.com",
        },
        { icon: "clock", text: "9:00 AM - 5:30 PM" },
      ],
      button: {
        color: "orange",
        children: "Reach Out to Us",
      },
      href: "#",
    },
    {
      title: "San Mateo",
      items: [
        {
          icon: "map-pin",
          text: "102 S El Camino Real, San Mateo, CA 94401",
          href: "#",
        },
        { icon: "phone", text: "(650) 328-1001", href: "tel:(650) 328-1001" },
        {
          icon: "mail",
          text: "info@careindeed.com",
          href: "mailto:info@careindeed.com",
        },
        { icon: "clock", text: "9:00 AM - 5:30 PM" },
      ],
      button: {
        color: "orange",
        children: "Reach Out to Us",
      },
      href: "#",
    },
    {
      title: "Palo Alto",
      items: [
        {
          icon: "map-pin",
          text: "228 Hamilton Avenue 3rd Floor Palo Alto CA 94301",
          href: "#",
        },
        { icon: "phone", text: "(650) 328-1001", href: "tel:(650) 328-1001" },
        {
          icon: "mail",
          text: "info@careindeed.com",
          href: "mailto:info@careindeed.com",
        },
        { icon: "clock", text: "9:00 AM - 5:30 PM" },
      ],
      button: {
        color: "orange",
        children: "Reach Out to Us",
      },
      href: "#",
    },
  ],
};

const OtherLocations: React.FC<OtherLocationsProps> = ({
  id = "other-locations",
  className,
  heading = "Heading",
  locations,
}) => {
  heading = heading ?? defaultProps.heading;
  locations = locations ?? defaultProps.locations;

  const [emblaRef] = useEmblaCarousel({
    align: "start",
    containScroll: false,
    inViewThreshold: 0.5,
    dragFree: true,
  });

  return (
    <section
      id={id}
      aria-label={id}
      className={cn(
        "mx-auto flex w-full max-w-lg flex-col pt-4 md:gap-6 md:px-6 md:py-8 lg:gap-8 lg:px-3 lg:py-10",
        className
      )}
    >
      <div className="flex flex-col gap-2 px-4 font-montserrat md:px-0 lg:gap-4">
        <h2 className="font-montserrat text-heading-4 text-secondary-500 md:text-heading-3 lg:text-heading-2">
          {heading}
        </h2>
      </div>

      <div
        ref={emblaRef}
        className="relative flex w-full overflow-hidden p-4 md:hidden"
      >
        <div className="relative flex flex-row gap-6">
          {locations.map((textCardListedLocationsItem, index) => (
            <TextCardListedLocations
              title={textCardListedLocationsItem.title}
              items={textCardListedLocationsItem.items}
              button={textCardListedLocationsItem.button}
              href={textCardListedLocationsItem.href}
              key={id + "-" + textCardListedLocationsItem.title}
              className={`col-span-4 w-full flex-[0_0_65%] ${index === 0 ? "ml-2" : ""}`}
            />
          ))}
        </div>
      </div>

      <div className="hidden grid-cols-4 gap-x-6 gap-y-8 md:grid">
        {locations.map((textCardListedLocationsItem) => (
          <TextCardListedLocations
            title={textCardListedLocationsItem.title}
            items={textCardListedLocationsItem.items}
            button={textCardListedLocationsItem.button}
            href={textCardListedLocationsItem.href}
            key={id + "-" + textCardListedLocationsItem.title}
            className="col-span-4 w-full md:col-span-2 lg:col-span-1"
          />
        ))}
      </div>
    </section>
  );
};

export default OtherLocations;
